import { render, staticRenderFns } from "./ProfileInstructor.vue?vue&type=template&id=394c3fa0&scoped=true"
import script from "./ProfileInstructor.vue?vue&type=script&lang=js"
export * from "./ProfileInstructor.vue?vue&type=script&lang=js"
import style0 from "./ProfileInstructor.vue?vue&type=style&index=0&id=394c3fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c3fa0",
  null
  
)

export default component.exports